module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm5_en.7214e363f55ddcdc7f22ac5c7ca23856.png";